<script setup lang="ts">import { ref as _ref } from 'vue';

import PopUp1 from '@/components/PopUp1.vue'
import PopUp2 from '@/components/PopUp2.vue'
import PopUp3 from '@/components/PopUp3.vue'
import { getCurrentLocale } from '@/lang'
import { useGtm } from '@gtm-support/vue-gtm'
import { onMounted, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { initBglForm } from './formUtils'

const gtm = useGtm()

function enableGtm() {
	gtm?.enable(true)
	document.removeEventListener('mousemove', enableGtm)
	document.removeEventListener('touchstart', enableGtm)
}
const route = useRoute()

onMounted(() => {
	if (route.path.match('thank-you')) { enableGtm() }
	else {
		document.addEventListener('mousemove', enableGtm)
		document.addEventListener('touchstart', enableGtm)
	}
	setTimeout(initBglForm, 100)
})

let showPopUp1 = _ref(false)
let showPopUp2 = _ref(false)
let showPopUp3 = _ref(false)
let mouseNearTop = _ref(false)
let mouseLeavingViewport = _ref(false)
let userInactive = _ref(false)
let inactivityTimer: number | null = _ref(null)

const isAboutToAbandon = computed(() => {
	return mouseNearTop.value || mouseLeavingViewport.value || userInactive.value
})

const excludeRoutes = ['/thank-you', '/get-the-best-offer']

function abandonLogic() {
	if (!isAboutToAbandon.value) return
	// Only show popup if language is English
	const currentLocale = getCurrentLocale()
	if (currentLocale === 'en' && !excludeRoutes.includes(route.path)) {
		showPopUp1.value = true
	}
}

function handleMouseMove(e: MouseEvent) {
	// Track if mouse is near the top of the viewport (typically indicates user might leave)
	mouseNearTop.value = e.clientY < 10
	// Reset inactivity timer
	if (inactivityTimer.value) {
		clearTimeout(inactivityTimer.value)
	}
	// Set inactivity timeout (consider user inactive after 60 seconds)
	inactivityTimer.value = setTimeout(() => {
		userInactive.value = true
	}, 60000) as unknown as number
}

function handleMouseLeave(e: MouseEvent) {
	// If mouse leaves through the top of the page
	if (e.clientY <= 0) {
		mouseLeavingViewport.value = true
	}
}

function handleMouseEnter() {
	mouseLeavingViewport.value = false
}

onMounted(() => {
	// Set up abandonment detection
	document.addEventListener('mousemove', handleMouseMove)
	document.addEventListener('mouseleave', handleMouseLeave)
	document.addEventListener('mouseenter', handleMouseEnter)

	// Initialize inactivity timer
	inactivityTimer.value = setTimeout(() => {
		userInactive.value = true
	}, 60000) as unknown as number

	// Watch for abandonment
	watch(isAboutToAbandon, abandonLogic)
})
</script>

<template>
	<ModalContainer />
	<PopUp1 v-if="showPopUp1" />
	<PopUp2 v-if="showPopUp2" />
	<PopUp3 v-if="showPopUp3" />
	<router-view />
</template>
